module.exports = {"id":"210923","name":"Mohammed Khalil Al Owais","rating":"72","photo":"./data/images/photos/2/210923.png","club":{"name":"Al Ahli","logo":"./data/images/clubs/AlAhli.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MohammedKhalilAlOwais0.json
// module id = 3069
// module chunks = 0